import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/pages/home/HomeContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/structure/GeneralContent/index.tsx");
